import { OrganizationId } from '@kaizenplatform/kaizen-id-entity';

import formatUrl from './formatUrl';

const getPurchasePointLinkUrl = (
  baseUrl: string,
  organizationId: OrganizationId,
  returnedUrl: string,
  quantity?: number,
): string => {
  return formatUrl(baseUrl, `/organizations/${organizationId}/to_account_point`, {
    returned_url: returnedUrl,
    quantity: quantity !== undefined ? quantity.toString() : '',
  });
};

export default getPurchasePointLinkUrl;
